// import { useEffect, useReducer,useRef,useState } from "react";
import { Link } from "react-router-dom";
// import { MyContext } from "./Contextor";
// import "./style.css";

export default function ClientForm(props) {
    return (
        <div>
            <h2>Questionnaire Freelance</h2>
        </div>
    )
}